import script from "./WageProcessStatus.vue?vue&type=script&setup=true&lang=ts"
export * from "./WageProcessStatus.vue?vue&type=script&setup=true&lang=ts"

import "./WageProcessStatus.vue?vue&type=style&index=0&id=ef97b414&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef97b414"]])

export default __exports__